<div class="nav my-2">
    <div *ngFor="let pill of pills"><a class="btn btn-outline-primary float-right" [routerLink]="pill.link" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="btn-primary">{{pill.caption}}</a></div>
</div>